import React from 'react';
import {
	InstructionsWrapper,
	InstructionHeader,
	InstructionList,
	Instruction,
	BoldText,
	ColsList,
	ColName,
} from './Instructions.styles';

const Instructions = ({ headerText, instructions }) => {
	const renderInstructions = str => {
		if (typeof str === 'string') {
			let parts = str.split('*');
			return parts.map((part, index) => {
				if (index % 2 !== 0) {
					return <BoldText key={index}>{part}</BoldText>;
				}
				return part;
			});
		} else {
			return (
				<ColsList>
					{str?.cols.map(col => {
						return <ColName>{col}</ColName>;
					})}
				</ColsList>
			);
		}
	};

	return (
		<React.Fragment>
			<InstructionsWrapper>
				<InstructionHeader>{headerText}:</InstructionHeader>
				<InstructionList>
					{instructions.map((instr, index) => (
						<Instruction key={index} type={typeof instr}>
							{renderInstructions(instr)}
						</Instruction>
					))}
				</InstructionList>
			</InstructionsWrapper>
		</React.Fragment>
	);
};

export default Instructions;
